<script setup lang="tsx">
import { onMounted, ref } from 'vue'
import { fetchCustomValues, type CustomValueMap } from '@/services/custom'
import type { CustomFieldDefinition, Response } from '@/models/api-generated'
import http from '@/services/http'
import format from './CustomValueDisplay.vue'

const props = defineProps<{
	table: string
	rowId: number
}>()

const custom = ref<CustomFieldDefinition[]>([])
const values = ref<CustomValueMap>()

onMounted(async () => {
	const { data } = await http.get<Response<CustomFieldDefinition[]>>(`api/customFields/${props.table}`)
	if (data.data?.length) {
		custom.value.push(...data.data)
		values.value = await fetchCustomValues(props.table, props.rowId)
	}
})

function getValue(definition: CustomFieldDefinition, rowId: number) {
	if (!values.value) return ''

	const rows = values.value[definition.id]
	if (!rows) return ''

	return rows[rowId] ?? ''
}
</script>

<template>
	<template v-if="custom.length && values">
		<div class="row mt-2 text-wrap" v-for="cf in custom" :key="`${cf.id}_${props.rowId}`">
			<div class="col">{{ cf.label }}</div>
			<div class="col text-end text-break">
				<format :field="cf" :value="getValue(cf, props.rowId)"></format>
			</div>
		</div>
	</template>
</template>
